import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  props: {
    shippingFormats: {
      type: Object,
      required: true,
    },
    selectedOption: {
      type: Number,
      default: 0,
    },
  },
})
export default class ProductShippingSelectorComponent extends Vue {
  currentOption = this.selectedOption;
  digitalShippingAvailable = this.shippingFormats.options[0].available;
  physicalShippingAvailable = this.shippingFormats.options[1].available;

  get optionSelected() {
    switch (
      this.digitalShippingAvailable +
      ' ' +
      this.physicalShippingAvailable
    ) {
      case 'true true':
        return this.shippingFormats.options[this.currentOption];
      case 'false true':
        this.currentOption = 1;
        return this.shippingFormats.options[this.currentOption];
      default:
        return this.shippingFormats.options[this.currentOption];
    }
  }

  selectShipping(option, index) {
    this.currentOption = index;
    this.$emit('select', this.currentOption);
  }
}
